import React from "react";
import Box from "@material-ui/core/Box";
import { TextField } from "@material-ui/core";
import classnames from "classnames";
import gameSetStyles from "../styles/GameSet.style";

const SetAndTiebreak = ({
	index,
	onChange = () => {},
	onTiebreakChange = () => {},
	onFocus = () => {},
	teamSide,
	score,
	maxScore,
	tiebreak,
	maxTiebreak,
	disabled,
	tiebreakDisabled
}) => {
	const classes = gameSetStyles();

	const getScoreValue = (value) => {
		return value ? Math.max(0, Number(value.replace(/[^0-9]/g, ""))) : null;
	};

	const getScoreDisplayValue = (value) =>
		value !== null && value !== undefined ? value : "";

	return (
		<Box display="flex">
			<TextField
				disabled={disabled}
				id={`${teamSide}-score-${index}`}
				variant="outlined"
				name={`${teamSide}-score-${index}`}
				className={classnames(classes.score, classes.scoreInput, {
					[classes.disabled]: disabled
				})}
				InputLabelProps={{
					shrink: true
				}}
				InputProps={{
					readOnly: disabled,
					inputProps: {
						max: maxScore,
						min: 0,
						maxLength: 2,
						step: 1
					}
				}}
				type="number"
				value={getScoreDisplayValue(score)}
				step="1"
				onFocus={onFocus}
				onChange={(e) => {
					onChange(
						Number(e.target.value) > maxScore
							? maxScore
							: getScoreValue(e.target.value)
					);
				}}
				placeholder="-"
			/>
			<div className={classes.spacingXs} />
			<TextField
				disabled={tiebreakDisabled}
				id={`${teamSide}-tiebreak-${index}`}
				variant="outlined"
				name={`${teamSide}-tiebreak-${index}`}
				className={classnames(classes.score, classes.tiebreakInput, {
					[classes.disabled]: tiebreakDisabled
				})}
				InputLabelProps={{
					shrink: true
				}}
				InputProps={{
					readOnly: tiebreakDisabled,
					inputProps: {
						max: maxTiebreak,
						min: 0,
						maxLength: 2,
						step: 1
					}
				}}
				type="number"
				value={getScoreDisplayValue(tiebreak)}
				step="1"
				onFocus={onFocus}
				onChange={(e) => {
					onTiebreakChange(
						Number(e.target.value) > maxTiebreak
							? maxTiebreak
							: getScoreValue(e.target.value)
					);
				}}
				placeholder="-"
				size="small"
			/>
		</Box>
	);
};

export default SetAndTiebreak;
